'use strict';

var React = require('react');

var SvgProductListIcon = function SvgProductListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.724 3c-1.02 0-1.994.415-2.701 1.149l-4.254 4.417c-1.04 1.08-1.023 2.792.036 3.852l4.113 4.112c.293.293.767.293 1.06 0 .293-.293.293-.767 0-1.06l-4.112-4.113c-.482-.481-.489-1.26-.016-1.75l4.253-4.418c.424-.44 1.01-.689 1.62-.689h1.975c.966 0 1.75.784 1.75 1.75v2.371c0 .358-.146.7-.403.948-.298.287-.307.762-.02 1.06.287.299.762.308 1.06.02.552-.53.863-1.262.863-2.028v-2.371c0-1.795-1.455-3.25-3.25-3.25h-1.974Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.448 7.5c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.75c0-.414.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75h-4.5c-.414 0-.75-.336-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.75c0-.414.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75h-4.5c-.414 0-.75-.336-.75-.75Z"
  }));
};
SvgProductListIcon.displayName = "ProductListIcon";

exports.SvgProductListIcon = SvgProductListIcon;
